import _toConsumableArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// ignore-string-externalization
import React from 'react';
import { ModuleCarousel } from '../ModuleCarousel/ModuleCarousel';
import { jsx as _jsx } from "react/jsx-runtime";
// This is declared / changed to a higher order function / component in order to break the circular dependency,
// as part of an effort to remove all circular deps from mrkt-web
// Unfortunately, passing Module as a prop to the underlying component, here, is not straightforward,
// given how it's used. Basically, up in ../index.tsx there's a MODULE_COMPONENTS lookup, and whatever
// is found there is rendered, with the same set of props. And so special casing this would require some
// special care, which I don't really feel comfortable doing, not being very familiar with this code ajr 1/25/2022
export var heroNarrativeCarouselModuleCreator = function heroNarrativeCarouselModuleCreator(Module) {
  return /*#__PURE__*/React.forwardRef(function (_ref, _) {
    var _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$headline = _ref.headline,
        headline = _ref$headline === void 0 ? '' : _ref$headline,
        _ref$supertext = _ref.supertext,
        supertext = _ref$supertext === void 0 ? '' : _ref$supertext,
        image = _ref.image,
        _ref$carouselSlides = _ref.carouselSlides,
        carouselSlides = _ref$carouselSlides === void 0 ? [] : _ref$carouselSlides,
        _ref$textColor = _ref.textColor,
        textColor = _ref$textColor === void 0 ? '' : _ref$textColor,
        _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
        _ref$contentType = _ref.contentType,
        contentType = _ref$contentType === void 0 ? '' : _ref$contentType,
        _ref$isVisible = _ref.isVisible,
        isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
    var coverSlide = {
      id: id,
      title: title,
      contentType: 'heroCaseStudyCover',
      headline: headline,
      supertext: supertext,
      image: image,
      textColor: textColor,
      backgroundColor: backgroundColor
    };
    var slides = [coverSlide].concat(_toConsumableArray(carouselSlides)).filter(Boolean);
    return /*#__PURE__*/_jsx(ModuleCarousel, {
      Module: Module,
      isHeader: false,
      carouselSlides: slides,
      contentType: contentType,
      title: title,
      isVisible: isVisible
    });
  });
};